module.exports = "/dist/images/camera-white.png?4641f09fbb37ae03b52abfca0f9d1706";